export const API_AUTH = {
  login: "/login",
  users: "/users"
};

export const API_AVPS = "/avps";
export const API_PROPERTIES = "/properties";
export const API_DEALS = "/deals";
export const API_DEAL_FETCH = "/deal/:dealId";
export const API_FUNDS = "/funds";
export const API_LOANS = "/loans";
export const API_USERS = "/users";
export const API_ROLES = "/roles";
export const API_NOTES = "/notes";
export const API_META = "/meta";
export const API_QUOTES = "/quotes";
export const API_SEARCH = "/search";
export const API_HEDGES = "/hedges";
